import { render } from "./Coupon.vue?vue&type=template&id=d368a56a&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=d368a56a&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d368a56a"]])

export default __exports__